import TransactionPassFormModel from './model/form.model.js';
import { success } from '@shared/ui/utils/toastr';

class TransactionPassController {
	constructor(SecurityApiService, SessionService) {
		'ngInject';

		this.SecurityApiService = SecurityApiService;
		this.SessionService = SessionService;
	}

	$onInit() {
		this.form = new TransactionPassFormModel();
		this.form.hasTransactionPasswordEnabled = this.SessionService.getSession().hasTransactionPasswordEnabled;
	}

	submit() {
		this.SecurityApiService.saveCredentials(this.form.toPayload())
		.then(() => {
			success(this.form.hasTransactionPasswordEnabled ? 'Transaction password has been successfully updated!' : 'Transaction password has been saved!');
			this.SessionService.set('hasTransactionPasswordEnabled', true);
			this.session = this.SessionService.getSession();
			this.form.hasTransactionPasswordEnabled = true;
			this.form.reset();
		})
		.catch((errors) => {
			this.form.setFormErrors(errors);
		})
		;
	}
}

export default TransactionPassController;



// WEBPACK FOOTER //
// ./client/app/pages/settings/component/transaction-authentication/transaction-pass/transaction-pass.controller.js